export * from './boundary-details-notification.component';